// extracted by mini-css-extract-plugin
export default {"bugFormContainer":"BugsModal_bugFormContainer__7C0cx"};